export function calculateDailyInterestCost(baseValue: number, interestPA: number) {
  return baseValue * (interestPA / 100 / 365);
}
